export default "__VITE_ASSET__d3lA7hQd__"